  $(function(){

    var open01 = $('.modal-open01'),
        close01 = $('.modal-close01'),
        container01 = $('.modal-container01'),
        open02 = $('.modal-open02'),
        close02 = $('.modal-close02'),
        container02 = $('.modal-container02')

    //開くボタンをクリックしたらモーダルを表示する
    open01.on('click',function(){	
      container01.addClass('active');
      return false;
    });

    //閉じるボタンをクリックしたらモーダルを閉じる
    close01.on('click',function(){	
      container01.removeClass('active');
    });

    //モーダルの外側をクリックしたらモーダルを閉じる
    $(document).on('click',function(e) {
      if(!$(e.target).closest('.modal-body01').length) {
        container01.removeClass('active');
      }
    });

    //開くボタンをクリックしたらモーダルを表示する
    open02.on('click',function(){	
      container02.addClass('active');
      return false;
    });

    //閉じるボタンをクリックしたらモーダルを閉じる
    close02.on('click',function(){	
      container02.removeClass('active');
    });

    //モーダルの外側をクリックしたらモーダルを閉じる
    $(document).on('click',function(e) {
      if(!$(e.target).closest('.modal-body02').length) {
        container02.removeClass('active');
      }
    });

    $('.js-pop-teiki').on('click', function() {
      $(".js-teiki").load("/pages/teiki .main-content", function() {
        $(".notes-box .faq dt").click(function () {
          $(this).next().slideToggle();
          $(this).toggleClass("active");
        });
      });
    });

    $('.js-pop-haisou').on('click', function() {
      $(".js-haisou").load("/policies/shipping-policy .main-content");
    });
});
 $(function(){
    /* matchHeight */
    $('.js-matchHeight').matchHeight();
    
    //商品詳細 もっと見る
	$('.readmore').click(function(){
		$(this).hide();
		$(this).prev('.item-info').addClass('no-hidden');
	});

    //商品詳細 アコーディオン
    $(".notes-box dl dt ").on("click", function() {
      $(this).next().slideToggle();
      $(this).toggleClass("active");
    });
    
    /* スライダー */
    $(".js-slider").slick({
      autoplay: true, // 自動再生を設定
      autoplaySpeed: 4000, // 自動再生のスピード（ミリ秒単位）
      dots: true, // ドットインジケーターの表示
      arrows: true,
    });

    /*lp01 お客様の声スライダー*/
   $(".users-voice-slider").slick({
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        arrows: true,
    });

     /* マイページのトグル */
    $(".js-toggle01").click(function () {
      $(".js-toggle-area01").slideToggle();
      $(this).toggleClass("active");
    });
    $(".js-toggle02").click(function () {
      $(".js-toggle-area02").slideToggle();
      $(this).toggleClass("active");
    });
   
});

